import React, { useState, useEffect } from "react";
import data1 from "../../images/hero-wave1.svg";
import data from "../../images/hero-wave2.svg";
import pr from "../../images/pricing-large.svg";
import moc from "../../images/Frame-2-3.png";
import moc1 from "../../images/Frame-7.png";
import mocb from "../../images/Frame-6-2.png";
import mocbb from "../../images/Frame-5-1.png";
import axios from "axios";
import Modal from "@mui/material/Modal";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";


export default function Main() {
  const [data, setData] = useState([]);
  useEffect(() => {
    const url = "https://cloudapp.aaragroups.com/api/banner-list/";

    axios
      .get(url, {
        headers: { Token: "c0b20629c2a198e2b1104fbd6adb696a35ed689f" },
      })
      .then((res) => setData(res?.data?.data?.banner_all_data))
      .catch((err) => console.log("err"));
  }, []);
  console.log(data);

  console.log(data);
  const [number, setNumber] = useState([]);

  return (
    <>
      <div class=" h1 overflow-x-hidden ">
        <div className="h2">
          <div
            style={{ backgroundImage: `url(${data1})` }}
            className=" h3"
          ></div>
          <div className=" h4"></div>
          <div
            style={{ backgroundImage: `url(${data})` }}
            className=" h5"
          ></div>
          <div className=" h6">
            <svg style={{ position: "absolute" }}>
              <clipPath id="clip">
                <path d="M1175.65 35.7644C962.846 -46.1285 865.751 35.6288 643.768 54.6084C421.786 73.588 391.68 33.0436 226.292 14.4975C60.9034 -4.0486 11.1228 90.8729 -67.9998 110.654C-67.9998 198.586 -67.9998 516 -67.9998 516L1508.19 516L1508.19 8.45359C1508.19 8.45359 1388.84 117.807 1175.65 35.7644Z"></path>
              </clipPath>
            </svg>
          </div>
       
          <div className="h7"></div>
        </div>
        <div className=" h8 !flex-col  !lg:flex">
          <div className="h9">
            <h1 className="h10 ">
            Freedom Offer
              <br />
              Speed & Security <br />
              <span>
                <span style={{ color: "white" }} className=" h11">
                Enabled 
                </span>
                Hosting
              </span>
            </h1>
            <p className="h12">
            Order Premium Web Hosting and get Free SSL included. We are available 24*7 with best support.
            </p>
            <button className="h13" >
              <div className=" h14">
                <div className=" h15 ring">
                  <svg
                    width="55"
                    height="55"
                    viewBox="0 0 55 55"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="27.5"
                      cy="27.5"
                      r="26.5"
                      stroke="url(#paint0_angular)"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-dasharray="3 20 8 1 10 8"
                    ></circle>
                    <defs>
                      <radialGradient
                        id="paint0_angular"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(27.5 27.5) rotate(107.904) scale(34.1541)"
                      >
                        <stop offset="0.0870822" stop-color="#844FFC"></stop>
                        <stop offset="0.69191" stop-color="#E1467C"></stop>
                      </radialGradient>
                    </defs>
                  </svg>
                </div>
                <div className=" h16 wrapper">
                  <img src={pr} alt="" class=" h19 icon" />
                </div>
                <div className=" h18">
                  <p className=" h20">Get Your Plan</p>
                  <p className="h21"></p>
                </div>
              </div>
            </button>
            
          </div>
          <div>
            <div className=" h23 lg:block hidden">
              <div className=" h24 mockup1">
                <div className="wrapper">
                  <img src={moc} alt="Mockup" />
                </div>
              </div>
              <div className="h25 mockup2">
                <div className="wrapper">
                  <img src={moc} alt="Mockup" />
                </div>
              </div>

              <div className="h26 mockup3">
                <img src={moc1} alt="Mockup" />
              </div>

              <div class=" h27 mockup4">
                <div class="wrapper">
                  <img src={mocb} alt="Mockup" />
                </div>
              </div>

              <div class=" h28 mockup5">
                <div class="wrapper">
                  <img src={mocbb} alt="Mockup" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    
     
    </>
  );
}
